import classnames from 'classnames';
import React from 'react';

export const getTableHeaderClassNames = (sortBy: 'ASC' | 'DESC' | null) =>
  classnames({
    sorted: Boolean(sortBy),
    ascending: sortBy === 'ASC',
    descending: sortBy === 'DESC',
  });

export const emptyTableState = (placeholder: React.ReactNode) => {
  return (
    <tbody>
      <tr>
        <td colSpan={10}>
          <p style={{ padding: '8px 12px', color: 'inherit' }}>{placeholder}</p>
        </td>
      </tr>
    </tbody>
  );
};
